import {
    FETCHED_WEBINAR,
    FETCHED_WEBINARS,
    CREATED_WEBINAR,
    UPDATED_WEBINAR,
    DELETED_WEBINAR,
    RESET_WEBINAR,
} from './types';

export function fetchedWebinars(data, totalPages) {
    return {
        type: FETCHED_WEBINARS,
        payload: {
            data: data,
            totalPages: totalPages,
        },
    };
}

export function fetchedWebinar(webinar) {
    return {
        type: FETCHED_WEBINAR,
        webinar,
    };
}

export function createdWebinar(response) {
    return {
        type: CREATED_WEBINAR,
    };
}

export function updatedWebinar(webinar) {
    return {
        type: UPDATED_WEBINAR,
        webinar,
    };
}

export function deletedWebinar(webinar) {
    return {
        type: DELETED_WEBINAR,
        webinar,
    };
}

export function resetWebinar() {
    return {
        type: RESET_WEBINAR,
    };
}



// WEBPACK FOOTER //
// ./src/containers/webinars/actions.js